import { HeightWidthTuple } from 'src/app/model/util-classes/height-width-tuple';
import StandardStickerPart from '../../../../../../../model/product/windowsticker/standard-sticker-part';

export class ClientWindowStickerStandardPartFormHelper {
  public static readonly SHAPE_OPTIONS = {
    LYING_DOWN: { label: 'Liggend' },
    SQUARE: { label: 'Vierkant' },
    UPRIGHT: { label: 'Opstaand' }
  };

  public static readonly SHAPE_OPTIONS_ARRAY: ShapeOption[] = Object.values(
    ClientWindowStickerStandardPartFormHelper.SHAPE_OPTIONS
  );

  public static getSelectedShapeOption(
    standardStickerPart: StandardStickerPart
  ): ShapeOption {
    if (
      standardStickerPart == null ||
      standardStickerPart.productSize == null ||
      standardStickerPart.productSize.height == null ||
      standardStickerPart.productSize.width == null
    ) {
      return null;
    }

    if (
      standardStickerPart.productSize.height <
      standardStickerPart.productSize.width
    ) {
      return this.SHAPE_OPTIONS.LYING_DOWN;
    } else if (
      standardStickerPart.productSize.height ===
      standardStickerPart.productSize.width
    ) {
      return this.SHAPE_OPTIONS.SQUARE;
    } else {
      // standardStickerPart.productSize.height > standardStickerPart.productSize.width
      return this.SHAPE_OPTIONS.UPRIGHT;
    }
  }

  public static getSelectedHeightWidth(
    standardStickerPart: StandardStickerPart,
    lyingDownOptions: HeightWidthTuple[],
    squareOptions: HeightWidthTuple[],
    uprightOptions: HeightWidthTuple[]
  ): HeightWidthTuple {
    if (
      standardStickerPart == null ||
      standardStickerPart.productSize == null ||
      standardStickerPart.productSize.height == null ||
      standardStickerPart.productSize.width == null
    ) {
      return null;
    }
    let toReturn = this.findMatchingTuple(
      standardStickerPart.productSize.height,
      standardStickerPart.productSize.width,
      lyingDownOptions
    );
    if (toReturn != null) {
      return toReturn;
    }
    toReturn = this.findMatchingTuple(
      standardStickerPart.productSize.height,
      standardStickerPart.productSize.width,
      squareOptions
    );
    return toReturn != null
      ? toReturn
      : this.findMatchingTuple(
          standardStickerPart.productSize.height,
          standardStickerPart.productSize.width,
          uprightOptions
        );
  }

  private static findMatchingTuple(
    height: number,
    width: number,
    tuples: HeightWidthTuple[]
  ): HeightWidthTuple {
    return tuples == null
      ? null
      : tuples.find(t => t.height === height && t.width === width);
  }
}

export interface ShapeOption {
  label: string;
}
